import { refreshAccessToken, loginWithTelegramInitData } from "../api/authApi";
import WebApp from "@twa-dev/sdk";
import { useAuthStore } from "../store/authStore";
import { logger } from "@/shared/utils/logger";

export const restoreSession = async (): Promise<boolean> => {
  const { setAccessToken } = useAuthStore.getState();
  const isMiniApp = !!WebApp.initData;

  try {
    logger.debug("Trying to restore session via refresh token...");
    const newToken = await refreshAccessToken();
    setAccessToken(newToken);
    logger.info("Access token restored via refresh.");
    return true;
  } catch (refreshError) {
    logger.warn("Refresh token invalid or expired.");

    if (isMiniApp) {
      try {
        logger.info("Re-authenticating in Mini App via initData...");
        const { accessToken } = await loginWithTelegramInitData(
          WebApp.initData
        );
        setAccessToken(accessToken);
        logger.info("Re-authentication via initData successful.");
        return true;
      } catch (miniAppError) {
        logger.error("Mini App re-authentication failed:", miniAppError);
      }
    }
  }

  return false;
};
